<template>
  <div class="my-login-page">
    <form @submit.prevent="confirm()">
      <div class="container h-100">
        <div
          class="row justify-content-md-center d-flex align-items-center h-100"
        >
          <div class="card-wrapper">
            <div class="card fat">
              <div class="card-header">
                <div class="logo d-flex justify-content-center">
                  <img
                    :src="require(`@/assets/logos/usecargobranco.png`)"
                    alt="pickndrive"
                    style="width: 120px; margin: 20%"
                  />
                </div>
              </div>
              <div class="card-body">
                <h4 class="card-title">ALTERAR E-MAIL</h4>
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-12">
                      <p>
                        Gostaria de alterar seu e-mail para:
                        <strong> {{ newEmail }} </strong>?
                      </p>
                    </div>
                  </div>
                </div>
                <div class="form-group no-margin">
                  <button type="submit" class="btn btn-success btn-block">
                    Confirmar Alteração
                  </button>
                  <button type="button" class="btn btn-danger btn-block">
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
            <div class="footer">
              Copyright &copy; Pick'n Drive 2018
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import AuthController from '../../controllers/AuthController.js';
import UserController from '../../controllers/UserController.js';
export default {
  data() {
    return {
      authController: new AuthController(
        this.$resource,
        this.$router,
        this.$message
      ),
      userController: new UserController(this.$resource),
      newEmail: this.$route.params.newEmail,
      currentEmail: this.$route.params.currentEmail,
      token: this.$route.params.token,
    };
  },

  created() {
    this.authController = new AuthController(
      this.$resource,
      this.$router,
      this.$message
    );

    this.authController.accessToChangeEmail(
      this.currentEmail,
      this.newEmail,
      this.token
    );
  },

  methods: {
    confirm() {
      this.userController.updateEmail({ email: this.newEmail }).then(() => {
        this.$message({
          type: 'success',
          message: 'E-mail alterado com sucesso!',
        });
        this.$router.push({ name: 'Login' });
      });
    },
  },
};
</script>

<style></style>
